module.exports = __webpack_public_path__ + "static/media/cog.a6b8e0e3.svg";